<inpla-dialog
  acceptButtonTitle="Accept"
  [contentStyleClass]="'pr-5'"
  [isLoading]="config.data.isLoading()"
  [controlsShown]="config.data.controlsShown"
  [scrollShadowVisible]="true"
  (onAcceptButtonClick)="acceptButtonClick()"
  (onCloseButtonClick)="cancelButtonClick()"
  (keydown.enter)="acceptButtonClick()"
>
  @if (config.data.isLoading()) {
    <div class="h-full flex justify-content-center align-items-center">
      <p-progressSpinner
        styleClass="w-3rem h-3rem"
        strokeWidth="5"
        ariaLabel="loading"
      ></p-progressSpinner>
    </div>
  } @else {
    <h4 class="color-white-grey-50 font-light mt-3">
      {{ config.data.releaseNote().releaseNoteDto.creationDate | date: 'dd MMM yyyy HH:mm' }}
    </h4>
    <h2 class="mt-5 mb-3">{{ config.data.releaseNote().releaseNoteDto.title }}</h2>
    <markdown class="markdown" [data]="config.data.releaseNote().releaseNoteDto.note" />
  }
</inpla-dialog>
